import '../../style/base.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/swipe/style/index.js
// module id = 104
// module chunks = 31